var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatentDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_16533)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2027_16533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 18,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.105225 0.5H16.4729V15.4993H-0.105225V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2027_16533)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07918 14.7108C0.90156 14.7108 0.746041 14.5924 0.698675 14.4211C0.651309 14.2498 0.723937 14.0682 0.876298 13.9766C2.21123 13.1769 2.76463 12.0125 2.9612 11.467C1.51021 10.3563 0.684326 8.81924 0.684326 7.21116C0.684326 6.39884 0.88814 5.61098 1.29075 4.87049C1.67442 4.16473 2.22229 3.53239 2.91778 2.99084C4.3285 1.89353 6.19867 1.28882 8.1841 1.28882C10.1695 1.28882 12.0397 1.89353 13.4504 2.99084C14.1459 3.53239 14.6938 4.16473 15.0775 4.87049C15.4801 5.61098 15.6837 6.39726 15.6837 7.21116C15.6837 8.02349 15.4801 8.80977 15.0775 9.55026C14.6938 10.256 14.1459 10.8884 13.4504 11.4299C12.0397 12.5272 10.1695 13.1319 8.1841 13.1319C7.36862 13.1319 6.56813 13.0301 5.80317 12.828C5.4645 13.0546 4.83137 13.454 4.07509 13.8306C2.90041 14.4148 1.8923 14.7108 1.07918 14.7108Z",
    fill: "#793F9D",
    stroke: "#793F9D",
    strokeWidth: 0.0789436
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18427 8.00059C7.96638 8.00059 7.78955 7.83777 7.78955 7.63876V4.02052C7.78955 3.82007 7.96638 3.65869 8.18427 3.65869C8.40215 3.65869 8.57899 3.82007 8.57899 4.02052V7.63876C8.57899 7.83777 8.40215 8.00059 8.18427 8.00059Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.157887
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18427 10.3674C7.96638 10.3674 7.78955 10.1898 7.78955 9.97273V9.18329C7.78955 8.96462 7.96638 8.78857 8.18427 8.78857C8.40215 8.78857 8.57899 8.96462 8.57899 9.18329V9.97273C8.57899 10.1898 8.40215 10.3674 8.18427 10.3674Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.157887
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_16533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatentDirectionIcon);
export default __webpack_public_path__ + "static/media/patent_direction_icon.315edb37301d36120a5e782300211159.svg";
export { ForwardRef as ReactComponent };